import DTConfirmation from '../DTConfirmationView/DTConfirmation';

const SendMacro = () => {
  return <DTConfirmation showDummyButton={true} />;
};

export default SendMacro;
